import styled from 'styled-components';

const PageContent = styled.div`
  margin-top: ${({ theme }) => theme.spacing.medium || '1.25rem'};
`;

export default PageContent;
